const theme = {
  font: {
    avenirBlack: 'Avenir Black',
    avenirBlackOblique: 'Avenir BlackOblique',
    avenirLight: 'Avenir Light',
    avenirLightOblique: 'Avenir LightOblique',
    avenirMedium: 'Avenir Medium',
    avenirMediumOblique: 'Avenir MediumOblique',
    avenirHeavy: 'Avenir Heavy',
    avenirHeavyOblique: 'Avenir HeavyOblique',
    glacialIndifference: 'Glacial Indifference'
  },
  fontWeight: {
    bold: 'bold',
    regular: 'normal',
    italic: 'italic'
  },
  color: {
    textLightWhite: 'rgb(244, 244, 244)',
    lightGrey: 'rgb(223, 223, 223)',
    grey: 'rgb(181, 181, 182)',
    white: 'rgb(255, 255, 255)',
    black: 'rgb(0,0,0)',
    mediumGrey: 'rgb(107,107,107)',
    thickGrey: 'rgb(68, 68, 69)',
    searchTextGrey: 'rgb(40, 40, 40)',
    backgroundGrey: 'rgb(118, 118, 123)',
    tableSeparatorGrey: 'rgb(151,151,151)',
    borderGrey: 'rgb(231, 231, 231)',
    tilesThickGrey: 'rgb(160,160,160)',
    tilesLightGrey: 'rgb(154,166,168)',
    shadowColor: 'rgba(0, 0, 0, 0.5)',
    lightShadowColor: 'rgba(0, 0, 0, 0.25)',
    primaryBlue: 'rgb(0,180,210)',
    mediumPrimaryBlue: 'rgba(0,180,210, 0.5)',
    lightPrimaryBlue: 'rgb(206 237 242)',
    primaryPink: 'rgb(217, 102, 157)',
    lightPrimaryPink: 'rgb(242, 196, 218)',
    red: 'rgb(217,72,82)',
    lightGreen: 'rgb(41,171,135)',
    orange: 'rgb(255,131,0)',
    transparent: 'rgba(0,0,0,0)',
    teal: '#425471'
  }
}

export default theme;